import { useTranslation, withTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  InputLabel,
  FormControl,
  NativeSelect,
} from '@material-ui/core';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import { fixCountryCodePageIssueIfRequired } from '../../../../../utils/common';
import selectBackground from '../../../../../images/select-bg.png';

const useStyles = makeStyles((theme) => ({
  fieldSelectNative: {
    '&.MuiInputBase-root': {
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
    '& .MuiNativeSelect-select': {
      height: '50%',
      background: `url(${selectBackground}) no-repeat right center;`,
    },
  },
  fieldSelectNativeBorder: {
    border: `1px solid ${theme?.palette?.custom?.lightBlack}`,
  },
  'field__select--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  errorMessage: {
    fontFamily: 'Formula1-Regular',
    fontSize: '12px',
    letterSpacing: '.5px',
    fontWeight: 500,
  },
}));

function CountryField(props) {
  const {
    form = {},
    name,
    externalData,
    addNewAddressFields,
    label,
    customClasses,
    onChange,
    placeholderLabel,
  } = props;
  const { values = {} } = form;
  const { t } = useTranslation();
  const classes = useStyles();
  const options =
    externalData?.countryRules?.data?.Codes || externalData?.countryRules;
  return (
    <Box className={`field field--${name}`} mb={4}>
      <InputLabel>
        <Typography
          variant="body1"
          color="textPrimary"
          className={customClasses && customClasses.titilliumFont}
        >
          {label || t(LocaleKeys.registration.countryOfResidence)}
        </Typography>
      </InputLabel>
      <FormControl
        className={`field__form-control ${
          customClasses && customClasses.fieldHeight
        }`}
      >
        <NativeSelect
          data-cy="field__select"
          data-testid="country-select"
          IconComponent={() => null}
          className={`field__select  ${classes.fieldSelectNative} ${
            form?.errors?.[name]
              ? classes['field__select--error']
              : classes.fieldSelectNativeBorder
          }
          }`}
          disableUnderline
          name={name}
          value={values[name] || 'Select'}
          onChange={(event) => {
            form.setFieldValue(name, event.target.value);
            //return true if any one of the error properties has an error
            const isAnyFormFieldError = (addressField, formData) =>
              addressField.some((fieldItem) =>
                formData?.errors?.hasOwnProperty(fieldItem),
              );
            if (
              name === 'Country' &&
              isAnyFormFieldError(addNewAddressFields, form)
            ) {
              //set only particular error property to an empty string
              addNewAddressFields?.forEach((fieldItem) => {
                form?.errors[fieldItem] && form.setFieldError(fieldItem, '');
              });
            }
            if (onChange) {
              onChange();
            }
          }}
        >
          <option value="Select">
            {placeholderLabel || t(LocaleKeys.registration.select)}
          </option>
          {options
            ? options.map((title, index) => (
                <option value={title?.Value} key={index}>
                  {fixCountryCodePageIssueIfRequired(title)}
                </option>
              ))
            : []}
        </NativeSelect>
      </FormControl>
      {form?.errors?.[name] ? (
        <Box ml={3} mt={2} className={`field__errorBox`}>
          <Typography
            variant="body2"
            color="error"
            className={classes.errorMessage}
          >
            {form.errors[name]}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}
export default compose(withTranslation())(CountryField);
